import type { FC, ReactNode } from 'react'

import { ArrowUpRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface SocialLinksProps {
    className?: string
    linkClassName?: string
}

export const SocialLinks: FC<SocialLinksProps> = ({ className, linkClassName }): ReactNode => {
    if (siteConfig.socials.length === 0) return null

    return (
        <ul className={cn('flex flex-wrap gap-x-6 gap-y-3', className)}>
            {siteConfig.socials.map(social => (
                <li key={social.label}>
                    <a
                        href={social.href}
                        target='_blank'
                        rel='noopener noreferrer'
                        className={cn(
                            'group inline-flex items-center gap-1.5 rounded-sm text-sm text-muted-foreground outline-none transition-colors duration-300 hover:text-white focus-visible:text-white focus-visible:ring-2 focus-visible:ring-ring',
                            linkClassName
                        )}
                    >
                        {social.label}
                        <ArrowUpRight
                            aria-hidden='true'
                            className='size-3.5 transition-transform duration-300 ease-smooth group-hover:-translate-y-0.5 group-hover:translate-x-0.5'
                        />
                        <span className='sr-only'> (opens in a new tab)</span>
                    </a>
                </li>
            ))}
        </ul>
    )
}
